import 'magnific-popup';

$('.article__featured .article__image a.image').magnificPopup({
  type: 'image',
  fixedContentPos: false,
  alignTop: true
});

if ($(window).width() > 767) {
  $('.product__images').on('click', 'a', function(e) {
    e.preventDefault();
    $.magnificPopup.open({
      items: {
        src: $(this).attr('href')
      },
      type: 'image',
      mainClass: 'mfp-fade'
    });
  });
} else {
  $('.product__images a').on('click', function(e) {
    e.preventDefault();
  });
}

$('.size-link, .product__utility-stylist').magnificPopup({
  type: 'inline',
  mainClass: 'mfp-fade'
});



// WEBPACK FOOTER //
// ../assets/js/popups.js